// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ScheduledOpArgs_abstract } from './../../abstract/SagaBase/Objects/ScheduledOpArgs_abstract';
export class ScheduledOpArgs extends ScheduledOpArgs_abstract {}
